@if (vm$ | async; as vm) {
  <v-public-bottom-gradient-wrapper>
    <div
      class="flex flex-col gap-10 w-[90vw] md:min-w-sm md:w-xl relative max-w-[480px]">
      <v-public-logo-header
        [header]="'pages.consent.header' | transloco"
        [subheader]="
          'pages.consent.subheader' | transloco
        "></v-public-logo-header>
      <v-card variant="glass-v2" padding="lg">
        @if (vm.currentConsent.data; as consent) {
          <div slot="body">
            @if (consent.skip) {
              <!-- Only show a spinner -->
              <div class="flex flex-col items-center justify-center h-10rem">
                <i class="pi pi-spin pi-spinner text-2xl"></i>
              </div>
            } @else {
              <!-- Show more detailed information about the consent request -->
              <div
                class="text-center flex flex-col items-center text-primary gap-3">
                <h3 class="text-2xl">
                  {{ consent.client.name || consent.client.id }}
                </h3>
                <div>{{ 'pages.consent.message' | transloco }}</div>
                <div>
                  <ul class="list-disc text-subtle">
                    @for (scope of consent.requestedScopes; track scope) {
                      <li>{{ scope }}</li>
                    }
                  </ul>
                </div>
              </div>
            }
          </div>
        }
        <div slot="footer">
          @if (!vm.currentConsent.data?.skip) {
            <div class="mt-6">
              <v-button-v2
                [fullWidth]="true"
                (press)="onConsent()"
                [loading]="vm.isLoading">
                {{ 'pages.consent.consentBtn' | transloco }}
              </v-button-v2>
            </div>
          }
        </div>
      </v-card>
    </div>
  </v-public-bottom-gradient-wrapper>
}
